import { render, staticRenderFns } from "./systemSettings.vue?vue&type=template&id=4b93c19f&scoped=true&"
import script from "./systemSettings.vue?vue&type=script&lang=js&"
export * from "./systemSettings.vue?vue&type=script&lang=js&"
import style0 from "./systemSettings.vue?vue&type=style&index=0&id=4b93c19f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b93c19f",
  null
  
)

export default component.exports